import AnswerChoices from "./AnswerChoices.js";

function Question(props) {
  return (
    <div>
      <div className="question">{props.question}</div>
      <div className="answers">
        <AnswerChoices
          answer={props.choices[0]}
          onClick={() => props.setAnswerState(props.choices[0])}
        />
        <AnswerChoices
          answer={props.choices[1]}
          onClick={() => props.setAnswerState(props.choices[1])}
        />
        <AnswerChoices
          answer={props.choices[2]}
          onClick={() => props.setAnswerState(props.choices[2])}
        />
        <AnswerChoices
          answer={props.choices[3]}
          onClick={() => props.setAnswerState(props.choices[3])}
        />

        {/*LAST STEP: {props.choices.map((choice, index) => (
          <AnswerChoices
            key={index}
            answer={choice}
            onClick={() => props.setAnswerState(choice)}
          />
        ))} */}
      </div>
    </div>
  );
}

export default Question;
